<template>
  <div>
    <div class="top-list">
      <div class="item">
        <span>总订单数</span>
        <span>{{ topBody.order_count }}</span>
      </div>
      <div class="item">
        <span>本月订单数</span>
        <span>{{ topBody.month_order_count }}</span>
      </div>
      <div class="item">
        <span>昨日订单数</span>
        <span>{{ topBody.yesterday_order_count }}</span>
      </div>
    </div>
    <el-main class="page-content-margin-unset">
      <el-radio-group
        v-model="body.type"
        @change="event().handleCurrentChange()"
        style="margin-bottom: 30px;">
        <el-radio-button label="1">年</el-radio-button>
        <el-radio-button label="2">月</el-radio-button>
        <el-radio-button label="3">日</el-radio-button>
      </el-radio-group>
      <div
        ref="orderData"
        style="width: 100%;height:400px;"/>
    </el-main>
  </div>
</template>

<script>
import { imgDomain } from '../../configs/env'
import timeChange from '../../mixins/time-change'
import { Statistics, StatisticsEchart } from '../../api/statistics'

const echarts = require('echarts');

export default {
  mixins: [timeChange],
  data() {
    return {
      imgDomain,
      tabPosition: '',
      topBody: {
      },
      body: {
        type: '1',
      },
      times: [],
      total: 0,
      tableData: [
        {},
      ],
      xAxisData: [],
      xdata: [],
      ydata: [],
    };
  },

  components: {
  },
  created() {
    this.network().Statistics()
    this.network().StatisticsEchart()
  },
  mounted() {
  },
  methods: {
    event() {
      return {
        handleCurrentChange: () => {
          this.network().StatisticsEchart()
        },
      }
    },
    network() {
      return {
        Statistics: async () => {
          const { status, data } = await Statistics()
          if (status !== 200) return
          this.topBody = data
        },
        StatisticsEchart: async () => {
          const { status, data } = await StatisticsEchart(this.body)
          if (status !== 200) return
          this.handler().setData(data)
        },
      }
    },
    handler() {
      return {
        createEchart: () => {
          const option = {
            color: ['#00bb68'],
            title: {
              text: '折线图堆叠',
            },
            tooltip: {
              trigger: 'axis',
            },
            legend: {
              data: ['订单数量'],
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true,
            },
            xAxis: {
              type: 'category',
              // boundaryGap: false,  // 是否贴边
              data: this.xdata,
            },
            yAxis: {
              type: 'value',
            },
            series: [
              {
                name: '订单数量',
                type: 'line',
                smooth: true,
                data: this.ydata,
              },
            ],
          };
          const myChart = echarts.init(this.$refs.orderData)
          myChart.setOption(option)
        },
        setData: (data) => {
          // value:当前年、月、日，下的月、日、时的总数
          // text:当前年、月、日，下的月、日、时
          // current:当前月份，日期，时
          // key: 接口返回数据的键名
          const type = [
            { value: 0, text: '' },
            {
              value: 12,
              text: '月',
              key: 'months',
              item: 'month',
              current: new Date().getMonth() + 1,
            },
            {
              // eslint-disable-next-line
              value: new Date(new Date().getFullYear(), parseInt(new Date().getMonth() + 1), 0).getDate(),
              text: '日',
              key: 'days',
              item: 'day',
              current: new Date().getDate(),
            },
            {
              value: 24,
              text: '点',
              key: 'hours',
              item: 'hour',
              current: new Date().getHours(),
            },
          ]
          console.log(type);


          this.xdata = []
          for (let i = 0; i < type[this.body.type].value; i += 1) {
            this.xdata.push(`${i + 1}${type[this.body.type].text}`)
          }
          this.ydata = []
          for (let i = 0; i < type[this.body.type].current; i += 1) {
            this.ydata.push(0)
          }
          data[type[this.body.type].key].forEach((item) => {
            this.ydata[item[type[this.body.type].item] - 1] = item.total_order
          });
          this.handler().createEchart()
        },
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top-list{
  display: flex;
  margin-bottom: 20px;
  .item{
    flex: 1;
    height: 150px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 5px 16px 0 rgba(42, 42, 68, .05);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &:nth-child(n+2){
      margin-left: 23px;
    }
    span{
      margin-bottom: 12px;
      &:last-child{
        font-size: 36px;
        color: #d70d18;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/statistics/order.vue